var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIpJacket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4c0 1.1 1.8 2 4 2s4-.9 4-2V3c0-.6-.4-1-1-1H9c-.6 0-1 .4-1 1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4c0 2 4 5 4 10v8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14c0-5 4-8 4-10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19H3c-.6 0-1-.4-1-1V7c0-1.1.8-2.3 1.9-2.6L8 3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9v12c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m16 3 4.1 1.4C21.2 4.7 22 5.9 22 7v11c0 .6-.4 1-1 1h-3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m6 15 2-2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m18 15-2-2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIpJacket);
export default __webpack_public_path__ + "static/media/icon-ip-jacket.814e2e0adbee8ef922b0f815a9f81b50.svg";
export { ForwardRef as ReactComponent };